import { lazyLoad } from 'utils/loadable';

export const AuditLogRouting = lazyLoad(
  () => import('./auditLog.routing'),
  (module) => module.AuditLogRouting
);
